exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-bg-div[data-v-7ce8d877]{min-height:640px}.btn-gold-tight[data-v-7ce8d877]{width:-webkit-max-content;width:max-content}.static-gradient-overlay[data-v-7ce8d877]:before{content:\"\";position:absolute;inset:0;z-index:2;background-color:#151516;opacity:.7}.details[data-v-7ce8d877]{background-color:rgba(0,0,0,.5)}.details[open] .summary-icon[data-v-7ce8d877]{--tw-rotate:180deg}summary[data-v-7ce8d877]::-webkit-details-marker{display:none}", ""]);

// exports
